/**
 * Cliente HTTP unico do front.
 * ARMADILHA 12: nada de .catch(() => null) — o erro sobe com mensagem.
 * O tratamento global de 401 e plugado aqui na Etapa 3.
 */
export class ErroApi extends Error {
  constructor(
    public status: number,
    public codigo: string,
    mensagem: string,
    public detalhes?: unknown,
  ) {
    super(mensagem);
    this.name = 'ErroApi';
  }
}

type AoExpirar = (mensagem: string) => void;
let aoExpirarSessao: AoExpirar | null = null;

export function registrarSessaoExpirada(cb: AoExpirar) {
  aoExpirarSessao = cb;
}

export async function api<T = unknown>(
  caminho: string,
  opcoes: RequestInit & { timeoutMs?: number } = {},
): Promise<T> {
  const { timeoutMs = 15000, ...init } = opcoes;

  // ARMADILHA 3: toda chamada com tempo limite.
  const ctrl = new AbortController();
  const timer = setTimeout(() => ctrl.abort(), timeoutMs);

  let resposta: Response;
  try {
    resposta = await fetch(`/api${caminho}`, {
      ...init,
      signal: ctrl.signal,
      credentials: 'same-origin',
      headers: {
        Accept: 'application/json',
        ...(init.body ? { 'Content-Type': 'application/json' } : {}),
        ...(init.headers ?? {}),
      },
    });
  } catch (e) {
    clearTimeout(timer);
    if ((e as Error).name === 'AbortError') {
      throw new ErroApi(0, 'tempo_esgotado', 'O servidor demorou demais para responder.');
    }
    throw new ErroApi(0, 'sem_conexao', 'Não consegui falar com o servidor.');
  }
  clearTimeout(timer);

  const texto = await resposta.text();
  const corpo = texto ? seguroJson(texto) : null;

  if (resposta.status === 401) {
    const msg = (corpo as any)?.mensagem ?? 'Sua sessão expirou, entre de novo';
    aoExpirarSessao?.(msg);
    throw new ErroApi(401, 'nao_autenticado', msg);
  }

  if (!resposta.ok) {
    throw new ErroApi(
      resposta.status,
      (corpo as any)?.erro ?? 'erro',
      (corpo as any)?.mensagem ?? `Falha na requisicao (${resposta.status})`,
      (corpo as any)?.detalhes,
    );
  }

  return corpo as T;
}

function seguroJson(texto: string): unknown {
  try {
    return JSON.parse(texto);
  } catch {
    return { mensagem: texto.slice(0, 300) };
  }
}
